
<!--
~ VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
~
~ This program is free software: you can redistribute it and/or modify
~ it under the terms of the GNU Affero General Public License as published by
~ the Free Software Foundation, version 3 of the License.
~
~ This program is distributed in the hope that it will be useful,
~ but WITHOUT ANY WARRANTY; without even the implied warranty of
~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
~ GNU Affero General Public License for more details.
~
~ You should have received a copy of the GNU Affero General Public License
~ along with this program. Look for COPYING file in the top folder.
~ If not, see http://www.gnu.org/licenses/.
-->

<div class="vp-task-notification"
  [@enterLeave]="item.state"
  (click)="onClick($event)"
  [class]="theClass"
  (mouseenter)="onEnter()"
  (mouseleave)="onLeave()">
  @if (item.type !== 'html') {
    <div class="vp-task-notification-default vp-task-notification-content-wrapper {{ item.type }}">
      @if (item.type === taskNotificationType.REMINDER) {
        <div class="vp-task-notification-title"><mat-icon>notifications_active</mat-icon><span>{{ 'REMINDER_TASK_DUE_TODAY' | translate }}</span></div>
      }
      @if (item.type === taskNotificationType.ASSIGNMENT) {
        <div class="vp-task-notification-title"><mat-icon>assignment_turned_in</mat-icon><span>{{ 'NEW_TASK_ASSIGNMENT_TITLE' | translate }}</span></div>
      }
      @if (item.type === taskNotificationType.TASK_UPDATE) {
        <div class="vp-task-notification-title"><mat-icon>assignment_turned_in</mat-icon><span>{{ 'TASK_UPDATE_TITLE' | translate }}</span></div>
      }
      @if (item.type === taskNotificationType.MENTIONING) {
        <div class="vp-task-notification-title"><mat-icon>assignment_turned_in</mat-icon><span>{{ 'TASK_MENTION_TITLE' | translate }}</span></div>
      }
      @if (item.type === taskNotificationType.OVERDUE_TASKS) {
        <div class="vp-task-notification-title"><mat-icon>assignment_late</mat-icon><span>{{ 'TASK_OVERDUE_TITLE' | translate }}</span></div>
      }
      @if (item.type === taskNotificationType.TODAY_DUE_TASKS) {
        <div class="vp-task-notification-title"><mat-icon>access_time</mat-icon><span>{{ 'TASK_DUE_TODAY_TITLE' | translate }}</span></div>
      }
      @if (item.type === taskNotificationType.DELETION) {
        <div class="vp-task-notification-title"><mat-icon>event_busy</mat-icon><span>{{ 'TASK_DELETE_TITLE' | translate }}</span></div>
      }
      @if (item.type === taskNotificationType.ASSIGNMENT_REMOVED) {
        <div class="vp-task-notification-title"><mat-icon>event_busy</mat-icon><span>{{ 'TASK_REMOVE_TITLE' | translate }}</span></div>
      }
      @if (item.type === taskNotificationType.TASK_WATCHER) {
        <div class="vp-task-notification-title"><mat-icon>visibility</mat-icon><span>{{ 'TASK_WATCHER_TITLE' | translate }}</span></div>
      }
      @if (!item?.override?.isMultiple) {
        <div class="vp-task-notification-content">
          @if (item.type === taskNotificationType.REMINDER) {
            <span>{{ 'TASK_DUE_TODAY' | translate }}</span>
          }
          @if (item.type === taskNotificationType.ASSIGNMENT) {
            <span>{{ 'NEW_TASK_ASSIGNMENT_SUB_TITLE' | translate }}</span>
          }
          @if (item.type === taskNotificationType.TASK_UPDATE) {
            <span>{{ 'TASK_UPDATE_SUB_TITLE' | translate }}</span>
          }
          @if (item.type === taskNotificationType.MENTIONING) {
            <span>{{ 'TASK_MENTION_SUB_TITTLE' | translate }}</span>
          }
          @if (item.type === taskNotificationType.DELETION) {
            <span>{{ 'TASK_DELETE_SUB_TITLE' | translate }}</span>
          }
          @if (item.type === taskNotificationType.ASSIGNMENT_REMOVED) {
            <span>{{ 'TASK_REMOVE_SUB_TITLE' | translate }}</span>
          }
          @if (item.type === taskNotificationType.TASK_WATCHER) {
            <span>{{ 'TASK_WATCHER_SUB_TITLE' | translate }}</span>
          }
          <br>
            <h6>{{ item.title }}</h6>
          </div>
        }
        @if (item?.override?.isMultiple) {
          <div class="vp-task-notification-content">
            @if (item.type === taskNotificationType.REMINDER) {
              <span>{{ 'TASK_DUE_TODAY' | translate }}</span>
            }
            @if (item.type === taskNotificationType.ASSIGNMENT) {
              <span>{{ 'NEW_TASK_ASSIGNMENT_SUB_TITLE' | translate }}</span>
            }
            @if (item.type === taskNotificationType.TASK_UPDATE) {
              <span>{{ 'TASK_UPDATE_SUB_TITLE' | translate }}</span>
            }
            @if (item.type === taskNotificationType.MENTIONING) {
              <span>{{ 'TASK_MENTION_SUB_TITTLE' | translate }}</span>
            }
            @if (item.type === taskNotificationType.DELETION) {
              <span>{{ 'TASK_DELETE_SUB_TITLE' | translate }}</span>
            }
            @if (item.type === taskNotificationType.ASSIGNMENT_REMOVED) {
              <span>{{ 'TASK_REMOVE_SUB_TITLE' | translate }}</span>
            }
            @if (item.type === taskNotificationType.TASK_WATCHER) {
              <span>{{ 'TASK_WATCHER_SUB_TITLE' | translate }}</span>
            }
            <br>
              <ul class="reminder-tasks-list-notification">
                @for (task of item.override.tasks; track task) {
                  <li (click)="$event.stopPropagation();$event.preventDefault();openTask(task)">{{ task.subject }}</li>
                }
              </ul>
            </div>
          }
          <div class="vp-task-notification-actions">
            <vnc-button (click)="cancel()"  class="notification-button" [height]="'medium'" [shape]="'rectangle'" [type]="'link'">
              <span>{{ 'CANCEL' | translate }}</span>
            </vnc-button>
            @if (!item?.override?.isMultiple && ( item.type !== taskNotificationType.OVERDUE_TASKS && item.type !== taskNotificationType.TODAY_DUE_TASKS && item.type !== taskNotificationType.DELETION && item.type !== taskNotificationType.ASSIGNMENT_REMOVED )) {
              <vnc-button (click)="openTask()"  class="notification-button" [height]="'medium'" [shape]="'rectangle'" [type]="'link'">
                <span>{{ 'OPEN_TASK' | translate }}</span>
              </vnc-button>
            }
            @if (item.type === taskNotificationType.OVERDUE_TASKS) {
              <vnc-button (click)="showOverdueTasks()"  class="notification-button" [height]="'medium'" [shape]="'rectangle'" [type]="'link'">
                <span>{{ 'SHOW_OVERDUE_TASKS' | translate }}</span>
              </vnc-button>
            }
            @if (item.type === taskNotificationType.TODAY_DUE_TASKS) {
              <vnc-button (click)="showDueTodayTasks()"  class="notification-button" [height]="'medium'" [shape]="'rectangle'" [type]="'link'">
                <span>{{ 'SHOW_DUE_TODAY_TASKS' | translate }}</span>
              </vnc-button>
            }
          </div>
        </div>
      }
    </div>
